import * as React from "react";
import { forwardRef } from "react";
const SvgClose2 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 10, viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9.66732 1.27337L8.72732 0.333374L5.00065 4.06004L1.27398 0.333374L0.333984 1.27337L4.06065 5.00004L0.333984 8.72671L1.27398 9.66671L5.00065 5.94004L8.72732 9.66671L9.66732 8.72671L5.94065 5.00004L9.66732 1.27337Z", fill: "#C3C3C3" }));
const ForwardRef = forwardRef(SvgClose2);
export default ForwardRef;
